import { createSlice } from '@reduxjs/toolkit';

const channelSlice = createSlice({
  name: 'channel',
  initialState: {
    items: [],
  },
  reducers: {
    setChannels(state, action) {
      state.items = action.payload;
    },
    addChannel(state, action) {
      state.items = [...state.items, action.payload];
    },
  },
});

export const { addChannel, setChannels } = channelSlice.actions;

export const selectChannels = state => state.channel.items;

export default channelSlice.reducer;
